import { Type } from '../type'
import any from '../any'
import array from '../array'
import number from '../number'
import object from '../object'
import string from '../string'

export function polygon() {
  return object({
    type: string().value('Polygon'),
    coordinates: array(array(array(number()))),
  })
}

export function multiPolygon() {
  return object({
    type: string().value('MultiPolygon'),
    coordinates: array(array(array(array(number())))),
  })
}

export function point() {
  return object({
    type: string().value('Point'),
    coordinates: array(number()),
  })
}

export function lineString() {
  return object({
    type: string().value('LineString'),
    coordinates: array(array(number())),
  })
}

export function multiLineString() {
  return object({
    type: string().value('MultiLineString'),
    coordinates: array(array(array(number()))),
  })
}

export function feature<T extends Type>(geometry: T) {
  return object({
    type: string().value('Feature'),
    properties: any(),
    geometry: geometry,
  })
}

export function featureCollection<T extends Type>(geometry: T) {
  return object({
    type: string().value('FeatureCollection'),
    features: array(feature(geometry)),
  })
}
